var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"priceLevel","resourceName":"Preisstufe","original":_vm.original,"attributes":[
      {
        name: 'at_amount',
        label: 'Ab',
        type: 'Number'
      },
      {
        name: 'bonus',
        label: 'Bonus',
        type: 'Number'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Preisstufe bearbeiten")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }